import { Cta, TrustLine } from "@/components/public/PublicChrome";
import { Reveal } from "@/components/public/Reveal";

export const Container = ({ className = "", children, testid }) => (
  <div className={`max-w-7xl mx-auto px-5 sm:px-8 ${className}`} data-testid={testid}>{children}</div>
);

export const H2 = ({ id, className = "", children }) => (
  <h2 id={id} className={`font-display text-2xl sm:text-3xl font-semibold tracking-[-0.02em] ${className}`}>{children}</h2>
);

export const PlanPill = ({ children, testid }) => (
  <p className="mt-4 inline-flex rounded-full border border-white/10 px-2.5 py-0.5 text-[11px] text-neutral-400" data-testid={testid}>{children}</p>
);

// Page opening shared by the public pages: big tight title, short intro, soft blue glow.
export function PageHeader({ title, intro, introTestid, testid }) {
  return (
    <header className="relative overflow-x-clip" data-testid={testid}>
      <div aria-hidden="true" className="hero-glow absolute -top-40 left-0 h-[560px] w-[1100px] max-w-none -z-10 pointer-events-none opacity-70" />
      <Container className="pt-16 sm:pt-24 rise">
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[1.03] max-w-4xl" data-testid={testid && `${testid}-title`}>{title}</h1>
        {intro && <p className="mt-6 text-base sm:text-lg text-neutral-300 max-w-2xl leading-relaxed" data-testid={introTestid}>{intro}</p>}
      </Container>
    </header>
  );
}

export function PageCta({ testid = "cta-signup" }) {
  return (
    <Container className="mt-24 sm:mt-32">
      <Reveal className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6 border-t border-white/[0.07] pt-10">
        <Cta testid={testid} />
        <TrustLine testid={`${testid}-trust-line`} />
      </Reveal>
    </Container>
  );
}
